import { useProcessLazyQuery } from "shared/api/process/queries.generated"
import { isProcessFinished } from "shared/lib/isProcessFinished"
import { repeatUntil } from "shared/lib/repeatUntil"
import { useEvent } from "shared/lib/useEvent"
import { ApolloFetchPolicy } from "shared/types/ApolloFetchPolicy"
import { Process } from "shared/types/__generated__/graphql"

export function useProcess(options?: { interval?: number; timeout?: number }) {
  const [fetchProcess] = useProcessLazyQuery({
    fetchPolicy: ApolloFetchPolicy.NETWORK_ONLY
  })

  const handleProcess = useEvent(
    <T>({
      process,
      onComplete
    }: {
      process: Process
      onComplete: (process: Process) => Promise<T>
    }) => {
      if (!process.id) {
        throw new Error("Process is missing ID")
      }
      if (process.finished) {
        return onComplete(process)
      }
      return repeatUntil(
        () =>
          fetchProcess({ variables: { id: process.id } }).then(
            result => result.data?.process || process
          ),
        isProcessFinished,
        onComplete,
        {
          initialInterval: options?.interval,
          timeout: options?.timeout,
          failurePredicateFn: p => p.error || null
        }
      ).promise
    }
  )

  return handleProcess
}
